import React from 'react';
import CheckBox from './../../../../components/CheckBox';

class PlantingDate extends React.Component  {

  constructor() {
    super();
    this.select = this.select.bind(this);
  }

  select(pd){
    this.props.selectValue(pd);
  }

  render(){

    let regions = {
      north :['127','083','075','035','107', '109', '029', '007', '019', '031', '089','001', '041', '003', '125', '023', '121', '067', '047', '123', '079', '065', '073', '129', '037', '077', '039', '045', '013', '063', '005', '133', '059', '131', '091', '113', '033'],
      central: ['115', '027', '055', '093', '085', '111', '061', '081', '049', '097', '009', '095', '105', '057', '103', '101', '053', '119', '069', '017', '117'],
      south: ['087','086','011','099', '021', '071', '051', '043','015']
    };

    let earlyName = "Early";
    let middleName = "Middle";
    let lateName = "Late";
 
    if(regions.north.includes(this.props.countySelected)){
      earlyName = earlyName + " (February 15 to March 4)";
      middleName = middleName + " (March 5 to March 21)";
      lateName = lateName + " (March 22 to April 5)";
    }else if(regions.central.includes(this.props.countySelected)){
      earlyName = earlyName + " (January 10 to February 1)";
      middleName = middleName + " (February 2 to February 25)";
      lateName = lateName + " (February 26 to March 11)";
    }else if(regions.south.includes(this.props.countySelected)){
      earlyName = earlyName + " (December 15 to January 10)";
      middleName = middleName + " (January 11 to February 5)";
      lateName = lateName + " (February 6 to February 20)";
    }

    const optionsPlantingDate = [{
      id: "early",
      name: earlyName
    },{
      id: "middle",
      name: middleName
    },{
      id: "late",
      name: lateName
    }]

    return (
      <div>
        <CheckBox handler={this.select} list={optionsPlantingDate}/>
      </div>
    );
  }
}

export default PlantingDate;
